import UITour from 'ui-shepherd-react/tour/UITour';
import { NEW_USER_ONBOARDING_TOUR_CONFIG, NEW_USER_ONBOARDING_TOUR_NAME } from '../config/NewUserOnboardingTourConfig';
import { useCallback, useContext, useEffect, useState } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { getTourStatus, setTourStatus } from 'onboarding-tours-client/onboardingToursClient';
import { useHistory } from 'react-router-dom';
import { getArticlesPath } from '../../routing/utils/internalPaths';
import { TourCompletionStatus } from 'onboarding-tours-client/constants';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFirstKBv3KB, getHasKBv3KB } from '../../migration-handler/singleton/migrationHandler';
import Raven from 'raven-js';
import { TourTrackingProvider } from 'ui-shepherd-tracker/contexts/TourTrackingProvider';
import { getIsAcceptanceTest } from '../../utils/localStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StartOnboardingModal = () => {
  const history = useHistory();
  const [displayingStartOnboardingModal, setDisplayingStartOnboardingModal] = useState(false);
  const {
    tour
  } = useContext(TourContext);
  const hasKBv3KB = getHasKBv3KB();
  useEffect(() => {
    if (!getIsAcceptanceTest()) {
      getTourStatus(NEW_USER_ONBOARDING_TOUR_NAME).then(({
        status
      }) => {
        if (status === TourCompletionStatus.INCOMPLETE) {
          setDisplayingStartOnboardingModal(true);
        }
      }).catch(e => {
        Raven.captureMessage('Failed to get tour status', {
          extra: {
            tourName: NEW_USER_ONBOARDING_TOUR_NAME,
            error: e
          }
        });
      });
    }
  }, []);
  const handleSkipTour = () => {
    setDisplayingStartOnboardingModal(false);
    setTourStatus(NEW_USER_ONBOARDING_TOUR_NAME, TourCompletionStatus.SKIPPED).catch(e => {
      Raven.captureMessage('Failed to set tour status', {
        extra: {
          status: TourCompletionStatus.SKIPPED,
          tourName: NEW_USER_ONBOARDING_TOUR_NAME,
          error: e
        }
      });
    });
  };
  const handleStartTour = useCallback(() => {
    const firstKBv3KB = getFirstKBv3KB();
    setDisplayingStartOnboardingModal(false);
    if (firstKBv3KB) {
      history.replace(getArticlesPath(firstKBv3KB.values.hs_id));
    }
    tour.start(NEW_USER_ONBOARDING_TOUR_NAME);
  }, [history, tour]);
  if (!displayingStartOnboardingModal || !hasKBv3KB) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.onboardingTour.startModal.title"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.onboardingTour.startModal.description"
        })
      }), /*#__PURE__*/_jsx(UIIllustration, {
        name: "knowledge-base"
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.onboardingTour.startModal.durationText"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleStartTour,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.startModal.startTourButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: handleSkipTour,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.startModal.skipTourButton"
          })
        })]
      })
    })]
  });
};
const NewUserOnboardingTour = ({
  children
}) => /*#__PURE__*/_jsx(TourTrackingProvider, {
  appName: "knowledge-content-ui",
  children: /*#__PURE__*/_jsxs(UITour, {
    tour: NEW_USER_ONBOARDING_TOUR_NAME,
    config: NEW_USER_ONBOARDING_TOUR_CONFIG,
    children: [/*#__PURE__*/_jsx(StartOnboardingModal, {}), children]
  })
});
export default NewUserOnboardingTour;